// extracted by mini-css-extract-plugin
export default {"tax-item":"fve03h","taxItem":"fve03h","ellipsis":"Lw195V"};